module.exports = __webpack_public_path__ + "img/p8.18733648.png";